var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-count-num",style:({
		fontSize: _vm.fontSize + 'rpx',
		fontWeight: _vm.bold ? 'bold' : 'normal',
		color: _vm.color
	})},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }